import React from 'react';
import { Grid, Box, Typography, Chip, Divider } from '@mui/material';
import FormSwitch from 'layouts/projects/Forms/FormComponents/FormSwitch';
import OutlinedFormTextField from 'layouts/projects/Forms/FormComponents/OutlinedFormTextField';
import FormSelect from 'layouts/projects/Forms/FormComponents/FormSelect';
import { validationSchemaKanatSheetTemplate } from 'layouts/projects/Forms/SheetTemplates/SheetTemplateForm/YupValidationSchemaSheets.js';
import { kanatToSheet, sheetToKanat } from '@samilkahraman/demand-namer';
import { BaseForm } from '../BaseForm';

export const KanatForm = (props) => {
    const allowedChanges = [
        'miktar',
        'en',
        'boy',
        'cumbaBandi',
        'menteseYeri',
        'camYeri',
        'kilitYeri',
        'hidrolik',
        'giyotin',
        'durbun',
        'sertAgacDonme',
    ];

    const renderFields = (formik, classes) => (
        <>
            {/* Temel ölçüler */}
            <Typography
                variant="subtitle2"
                sx={{
                    color: "#64748B",
                    mb: 1.5,
                    fontWeight: 500
                }}>
                Temel Ölçüler
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}>
                    <OutlinedFormTextField
                        itemID="miktar"
                        label="Miktar (Adet)"
                        placeHolder="Örn: 1000"
                        type="number"
                        formik={formik}
                        step="1"
                        adornment="AD"
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}>
                    <OutlinedFormTextField
                        itemID="en"
                        label="En"
                        placeHolder="Örn: 82"
                        type="number"
                        formik={formik}
                        step="0.1"
                        adornment="CM"
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}>
                    <OutlinedFormTextField
                        itemID="boy"
                        label="Boy"
                        placeHolder="Örn: 209"
                        type="number"
                        formik={formik}
                        step="0.1"
                        adornment="CM"
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}>
                    <FormSelect
                        itemID="cumbaBandi"
                        formik={formik}
                        inputName="Cumba Bandı"
                        items={[
                            { name: 'Yok', value: 'Yok' },
                            { name: '2 Kenar', value: '2 Kenar' },
                            { name: '4 Kenar', value: '4 Kenar' },
                        ]}
                        helperText={'Kanat Cumba Bandı'}
                    />
                </Grid>
            </Grid>

            {/* Yerler */}
            <Typography
                variant="subtitle2"
                sx={{
                    color: "#64748B",
                    mb: 1.5,
                    fontWeight: 500
                }}>
                Yerler
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 4
                    }}>
                    <FormSelect
                        itemID="menteseYeri"
                        formik={formik}
                        inputName="Menteşe Yeri"
                        items={[
                            { name: 'Yok', value: 'Yok' },
                            { name: 'Yönlü 2', value: 'Yönlü 2' },
                            { name: 'Yönlü 3', value: 'Yönlü 3' },
                            { name: 'Gömme 2', value: 'Gömme 2' },
                            { name: 'Gömme 3', value: 'Gömme 3' },
                        ]}
                        helperText={'Menteşe Yeri'}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 4
                    }}>
                    <FormSelect
                        itemID="camYeri"
                        formik={formik}
                        inputName="Cam Yeri"
                        items={[
                            { name: 'Yok', value: 'Yok' },
                            { name: 'Standart', value: 'Standart' },
                            { name: 'Giyotin', value: 'Giyotin' },
                        ]}
                        helperText={'Cam Yeri'}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 4
                    }}>
                    <FormSelect
                        itemID="kilitYeri"
                        formik={formik}
                        inputName="Kilit Yeri"
                        items={[
                            { name: 'Yok', value: 'Yok' },
                            { name: 'Standart Kale', value: 'Standart Kale' },
                            { name: 'Topuz', value: 'Topuz' },
                            { name: 'Otel Tipi', value: 'Otel Tipi' },
                        ]}
                        helperText={'Kilit Yeri'}
                    />
                </Grid>
            </Grid>

            {/* Ek Özellikler */}
            <Typography
                variant="subtitle2"
                sx={{
                    color: "#64748B",
                    mb: 1.5,
                    fontWeight: 500
                }}>
                Ek Özellikler
            </Typography>
            <Box
                sx={{
                    p: 2,
                    border: '1px solid #EEEEEE',
                    borderRadius: '6px',
                    backgroundColor: 'white',
                }}
            >
                <Grid container spacing={2}>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6
                        }}>
                        <FormSwitch formik={formik} name="hidrolik" label="Hidrolik Yeri" />
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6
                        }}>
                        <FormSwitch formik={formik} name="giyotin" label="Giyotin Kesim" />
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6
                        }}>
                        <FormSwitch formik={formik} name="durbun" label="Dürbün Yeri" />
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 6
                        }}>
                        <FormSwitch formik={formik} name="sertAgacDonme" label="Sert Ağaç Dönülmesi" />
                    </Grid>
                </Grid>
            </Box>
        </>
    );

    return (
        <BaseForm
            {...props}
            validationSchema={validationSchemaKanatSheetTemplate}
            allowedChanges={allowedChanges}
            toSheet={kanatToSheet}
            fromSheet={sheetToKanat}
            renderFields={renderFields}
        />
    );
};

export const KanatBadges = (props) => {
    const { initial } = props;
    const values = sheetToKanat(initial);

    const renderBadge = (label, value) => (
        <Chip
            label={`${label}: ${value !== undefined ? value : '-'}`}
            size="small"
            sx={{
                m: 0.5,
                bgcolor: 'white',
                border: '1px solid #E5E7EB',
                color: '#64748B',
                fontSize: '0.7rem',
                height: '24px',
                '& .MuiChip-label': {
                    px: 1,
                },
            }}
        />
    );

    return (
        <Box>
            <Typography
                variant="caption"
                sx={{
                    color: "#64748B",
                    display: 'block',
                    mb: 1,
                    fontWeight: 500
                }}>
                Teknik Özellikler
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {renderBadge('KALINLIK', values.kalinlik)}
                {renderBadge('DERZ ŞEKLİ', values.derzSekli)}
                {renderBadge('DERZ TİPİ', values.derzTipi)}
                {renderBadge('DERZ ADEDİ', values.derzAdedi)}
                {renderBadge('DERZ BIÇAK ADEDİ', values.derzBicakAdedi)}
                {renderBadge('Max Derz Derinligi (CM)', values.maxDerzDerinligi)}
                {renderBadge('Cumba TİPİ', values.cumbaTipi)}
                {renderBadge('Cumba Kalınlığı (MM)', values.cumbaKalinligi)}
                {renderBadge('CİNS', values.cins)}
                {renderBadge('CİNS Açıklaması', values.cinsAciklama)}
                {renderBadge('Dolgu TİPİ', values.dolguTipi)}
                {renderBadge('MDF Yüzey Kalınlığı (CM)', values.mdfYuzeyKalinlik)}
                {values.ekNot && renderBadge('NOTLAR', values.ekNot)}
            </Box>
        </Box>
    );
};
